export default __webpack_public_path__ + "static/media/prohibited_item.da9d56df.pdf";